// import Contact from '../../components/Contact'
import Corousal from '../components/Carousal'
import Description from '../components/Description'
import Header from '../components/Header'
import IconDesc from '../components/IconDesc'
import Image from '../components/Image'
import ImageDesc from '../components/ImageDesc'
import Images from '../components/Images'
import {PageFull} from '../components/Pages'
import bannerImg from '../assets/images/cambanner.jpg'
import bannerImg2 from '../assets/images/app devices.jpg'
import camicon from '../assets/images/camicon.png'



// govt logo
// startup india logo
// dipp number
// gst number



const headerButtons = [
    {
        'label': 'CTA Button',
        'link': '#footer'
    },
    // {
    //     'label': 'Test button',
    //     'link': '#footer'
    // }
]

const iconDescriptions = [
    {'img': camicon, 'description': 'Lorem ipsum dolor sit amet'},
    {'img': bannerImg, 'description': 'Lorem ipsum dolor sit amet'},
    {'img': camicon, 'description': 'Lorem ipsum dolor sit amet'},
    {'img': bannerImg, 'description': 'Lorem ipsum dolor sit amet'},
    {'img': camicon, 'description': 'Lorem ipsum dolor sit amet'},
    {'img': bannerImg, 'description': 'Lorem ipsum dolor sit amet'},
]


const imageDescs = [
    {
        'img': bannerImg,
        'title': 'Title title',
        'description': 'Lorem ipsum dolor sit amet ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat. Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla pariatur. Excepteur sint occaecat cupidatat non proident, sunt in culpa qui officia deserunt mollit anim id est laborum.'
    },
    {
        'img': bannerImg2,
        'title': 'Title title',
        'description': 'Lorem ipsum dolor sit amet ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat. Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla pariatur. Excepteur sint occaecat cupidatat non proident, sunt in culpa qui officia deserunt mollit anim id est laborum.'
    }
]

const images = [
    {
        'img': bannerImg,
        'title': 'Title title tiele',
        'description': 'Lorem ipsum dolor sit amet ut labore et dolore magna aliqua. Ut enim ad minim veniam'
    },
    {
        'img': bannerImg2,
        'title': 'Title title tiele',
        'description': 'Lorem ipsum dolor sit amet ut labore et dolore magna aliqua. Ut enim ad minim veniamq'
    },
    {
        'img': bannerImg,
        'title': 'Title title tiele',
        'description': 'Lorem ipsum dolor sit amet ut labore et dolore magna aliqua. Ut enim ad minim veniam'
    },
    {
        'img': bannerImg2,
        'title': 'Title title',
        'description': 'Lorem ipsum dolor sit amet ut labore et dolore magna aliqua. Ut enim ad minim veniamq'
    },
    {
        'img': bannerImg,
        'title': 'Title title',
        'description': 'Lorem ipsum dolor sit amet ut labore et dolore magna aliqua. Ut enim ad minim veniam'
    },
    {
        'img': bannerImg2,
        'title': 'Title title',
        'description': 'Lorem ipsum dolor sit amet ut labore et dolore magna aliqua. Ut enim ad minim veniamq'
    }
]


export default function Home() {
    return (
        <PageFull>
            <Header 
                title='Header Title'     
                img={bannerImg}
                buttons={headerButtons}
                />
            <Description title={'Description'} description={'iverto.ai is an innovative AI technology company focused on transforming industries through advanced vision solutions. We specialize in harnessing the power of artificial intelligence to deliver cutting-edge applications such as surveillance, anomaly detection, SOP procedure verification, and quality inspections. Our mission is to provide businesses with intelligent, scalable, and reliable tools to enhance security, streamline operations, and ensure the highest standards of performance. With a team of passionate innovators, we are committed to shaping a smarter, safer, and more efficient future across various sectors, from retail and manufacturing to healthcare and logistics. At Iverto.ai, we believe in using AI to solve real-world challenges, driving growth and efficiency for our clients.'}/>
            <IconDesc 
            title={'Icon Descriptions'} 
            items={iconDescriptions}/>
            <ImageDesc title='Descriptions with Images' items={imageDescs}/>
            <Corousal title='Carusal Images' items={imageDescs}/>
            <Image title='Single Image' img={bannerImg2}/>
            <Images title='Images Descriptions' items={images}/>
        </PageFull>
    );
}